
    import { defineComponent } from 'vue'
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import activitiesService from '@/apps/shared/services/getActivities-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    const FISCAL_CONDITIONS: Record<number, string> = {
        1: 'Responsable inscripto',
        3: 'Exento',
        4: 'Consumidor Final',
        7: 'Monotributista'
    };


    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                isBack: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/Integro-Max' },
                    { text: 'Cotizá tu seguro de Accidentes personales', path: '/Integro-Max/DatosContratante' },
                ],
                selectedLocality: null,
                activities: [],
                selectedActivity: null,
                fiscalCondition: 4,
                personType: 0,
                errorRadioFiscalCondition: false,
                errorRadioPersonType: false,
                dataTwoTabJson: null,
                backExit: false,
                showFiscalCondition: true,
                referente: null,
                medium: null,
                pas: null,
            }
        },
        methods: {

            validate() {
                var validation =
                    NF.Validation.Form.validate('#formTabTwo')
                    && this.personType != null
                    && this.fiscalCondition != null;


                return validation;
            },

            siguiente() {
                var validate = this.validate();

                if (!validate) {
                    if (this.personType == null) {
                        this.errorRadioPersonType = true;
                    }
                    else {
                        this.errorRadioPersonType = false;
                    }
                    if (this.fiscalCondition == null) {
                        this.errorRadioFiscalCondition = true;
                    }
                    else {
                        this.errorRadioFiscalCondition = false;
                    }

                    const eventData = {
                        'pas': this.pas,
                        'email': this.email,
                        'product': 'apintegro',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-apintegro-datos-personales',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);
                }
                else {
                    var dataTwoTab = {
                        selectedLocality: this.selectedLocality,
                        selectedActivity: this.selectedActivity,
                        personType: this.personType,
                        fiscalCondition: this.fiscalCondition,
                        fiscalConditionName: this.getFiscalConditionName()
                    }

                    sessionStorage.removeItem("TabTwoData");
                    sessionStorage.setItem("TabTwoData", JSON.stringify(dataTwoTab));

                    this.$router.push({
                        name: 'integro-max-tab-three',
                    })
                }

                if (this.backExit) {
                    sessionStorage.setItem("ExitOrContinueModal", "false");
                }
                else {
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                }
            },

            getActivities() {
                let product = 711;
                activitiesService.getactivities(product).then(async activities => {
                    this.activities = activities.map(element => ({
                        ...element, code: element["Id"], text: element["activityDescription"]
                    }));
                });
            },

            volver() {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'integro-max-tab-One',
                })
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAPIntegroGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async pageCustomization() {
                const defaultTitle = 'Íntegro Max';
                const actualPath = '/Integro-Max';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            getFiscalConditionName(): string | null {
                return FISCAL_CONDITIONS[this.fiscalCondition] ?? null;
            },
        },

        watch: {
            personType(newVal) {
                if (newVal == 0) {
                    this.fiscalCondition = 4;
                    this.showFiscalCondition = true;
                }
                else {
                    this.showFiscalCondition = false;
                    this.fiscalCondition = 1;
                }
            },
        },

        async mounted() {
            NF.UI.Page.block();

            sessionStorage.setItem("ExitOrContinueModal", "true");

            const parallelPromises = [
                this.pageCustomization(),
                this.updateByProductGoogleAnalytics(),
            ];

            await Promise.all([
                ...parallelPromises,
            ]);

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            this.getActivities()

            const tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
            this.email = tabOneWelcome.email;
            this.selectedLocality = tabOneWelcome.selectedLocality;

            const eventData = {
                'pas': this.pas,
                'email': this.email,
                'product': 'apintegro',
                'event': 'cotizador-apintegro-datos-personales',
                'referente': this.referente,
                'medio': this.medium
            };

            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push(eventData);

            const customWindow = window as typeof window & {
                _qsie?: Array<typeof eventData>;
            };

            customWindow._qsie ??= [];
            customWindow._qsie.push(eventData);

            var validBack = sessionStorage.getItem("pressBack");
            if (validBack) {
                sessionStorage.removeItem("pressBack");
                this.backExit = true;
            }
            else {
                this.isBack = false;
                this.backExit = false;
            }
            var dataTwoTab = sessionStorage.getItem("TabTwoData");
            if (dataTwoTab != null) {
                this.dataTwoTabJson = JSON.parse(dataTwoTab!);
                this.selectedActivity = this.dataTwoTabJson.selectedActivity;
                this.fiscalCondition = this.dataTwoTabJson.fiscalCondition;
                this.personType = this.dataTwoTabJson.personType;
                NF.UI.Page.unblock();
            }
            else {
                NF.UI.Page.unblock();
            }
        }

    })
